export const pluralize = (count, plural, singular, includeCount = true) => {
  if (includeCount) {
    return count === 1 ? `1 ${singular}` : `${count} ${plural}`;
  }

  return count === 1 ? singular : plural;
};

export const capitalize = (string) => string.charAt(0).toUpperCase() + string.slice(1);

export const normalizeNumber = (value) => {
  if (isNaN(value)) {
    return 0;
  }
  return value;
};



// WEBPACK FOOTER //
// ./src/js/utils/string-helpers.js